import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '../../../../../../components/Footer/components/Links/components/Link/components/Container.js';
import { MaskedLink } from '../../../../../../components/internal/MaskedLink/index.js';
const LinkComponent = ({
  href,
  masked,
  children,
  custom,
  ariaLabel,
  target = '_self'
}) => masked ? _jsx(MaskedLink, {
  href: href,
  rel: "noreferrer",
  target: target,
  children: _jsx(Container, {
    custom: custom,
    as: "span",
    children: children
  })
}) : _jsx(Container, {
  target: target,
  custom: custom,
  href: href,
  rel: "noreferrer",
  "aria-label": ariaLabel,
  children: children
});
export const Link = /*#__PURE__*/_styled(LinkComponent, process.env.NODE_ENV === "production" ? {
  target: "ej809qo0"
} : {
  target: "ej809qo0",
  label: "Link"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUswQyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICcuLi8uLi8uLi8uLi8uLi8uLi9jb21wb25lbnRzL0Zvb3Rlci9jb21wb25lbnRzL0xpbmtzL2NvbXBvbmVudHMvTGluay9jb21wb25lbnRzL0NvbnRhaW5lci5qcyc7XG5pbXBvcnQgeyBNYXNrZWRMaW5rIH0gZnJvbSAnLi4vLi4vLi4vLi4vLi4vLi4vY29tcG9uZW50cy9pbnRlcm5hbC9NYXNrZWRMaW5rL2luZGV4LmpzJztcbmNvbnN0IExpbmtDb21wb25lbnQgPSAoeyBocmVmLCBtYXNrZWQsIGNoaWxkcmVuLCBjdXN0b20sIGFyaWFMYWJlbCwgdGFyZ2V0ID0gJ19zZWxmJywgfSkgPT4gbWFza2VkID8gKF9qc3goTWFza2VkTGluaywgeyBocmVmOiBocmVmLCByZWw6IFwibm9yZWZlcnJlclwiLCB0YXJnZXQ6IHRhcmdldCwgY2hpbGRyZW46IF9qc3goQ29udGFpbmVyLCB7IGN1c3RvbTogY3VzdG9tLCBhczogXCJzcGFuXCIsIGNoaWxkcmVuOiBjaGlsZHJlbiB9KSB9KSkgOiAoX2pzeChDb250YWluZXIsIHsgdGFyZ2V0OiB0YXJnZXQsIGN1c3RvbTogY3VzdG9tLCBocmVmOiBocmVmLCByZWw6IFwibm9yZWZlcnJlclwiLCBcImFyaWEtbGFiZWxcIjogYXJpYUxhYmVsLCBjaGlsZHJlbjogY2hpbGRyZW4gfSkpO1xuZXhwb3J0IGNvbnN0IExpbmsgPSBzdHlsZWQoTGlua0NvbXBvbmVudCkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1pbmRleC5qcy5tYXAiXX0= */");